import { IResultDetail } from '@app/api/result.api';
import { Descriptions } from 'antd';
import { Table } from 'components/common/Table/Table';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface SpeakReadAloudProps {
  data: IResultDetail;
}

interface Column {
  title: string;
  dataIndex: string;
  key?: string;
}

export const SpeakDescribeImage: React.FC<SpeakReadAloudProps> = ({ data }) => {
  const { t } = useTranslation();

  const [columns, setColumns] = useState<Column[]>([]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [dataScore, setDataScore] = useState([{ key: 1, content: 0, pronunciation: 0, fluency: 0, total: 0 }]);

  useEffect(() => {
    setColumns([
      { title: t('page.results.detailTable.content'), dataIndex: 'content', key: 'content' },
      { title: t('page.results.detailTable.pronunciation'), dataIndex: 'pronunciation', key: 'pronunciation' },
      { title: t('page.results.detailTable.fluency'), dataIndex: 'fluency', key: 'fluency' },
      { title: t('page.results.detailTable.total'), dataIndex: 'total', key: 'total' },
    ]);
  }, [t]);

  return (
    <Descriptions bordered column={1} title={t('page.results.answerDetail')} size="small">
      <Descriptions.Item label={t('page.results.question')}>
        <img src={data.image_url} style={{ maxWidth: '300px' }} />
      </Descriptions.Item>
      <Descriptions.Item label={<span style={{ whiteSpace: 'nowrap' }}>{t('page.results.correctAnswer')}</span>}>
        {data.phrase_hints}
      </Descriptions.Item>
      <Descriptions.Item label={<span style={{ whiteSpace: 'nowrap' }}>{t('page.results.yourAnswer')}</span>}>
        <audio controls>
          <source src={`${process.env.REACT_APP_BASE_URL}${data.audio}`} type="audio/mpeg" />
          Your browser does not support the audio element.
        </audio>
      </Descriptions.Item>
      <Descriptions.Item label={t('page.results.score')}>
        <Table columns={columns} dataSource={dataScore} scroll={{ x: 800 }} pagination={false} />
      </Descriptions.Item>
    </Descriptions>
  );
};
